import './GenericTrialForm.scss'

import React, { FunctionComponent } from 'react'
import FormBuilder, { FormBuilderProps } from 'Root/Shared/components/builders/FormBuilder'
import { t } from 'ttag'

declare global {
    interface Window { generator: any, uniqid: string, dataLayer: any }
}
const GenericTrialForm: FunctionComponent = () => {
    const WORKFLOW_ACTION = "$System.Form.Generic.Action$"

    const inputDefault = {
        "puxFormElementOptions": {
            "formElementOptionsDisabled": false,
            "formElementOptionsAutofocus": false,
            "formElementOptionsAutocomplete": false,
            "formElementOptionsMultiple": false,
            "formElementOptionsStep": 1,
            "formElementOptionsCssClass": "mauticform-input",
            "formElementOptionsReadOnly": false
        },
        "puxFormElementValidation": {
            "formElementValidationRequired": false,
            "formElementValidationPattern": undefined,
            "formElementValidationMin": NaN,
            "formElementValidationMax": NaN,
            "formElementValidationMinLength": NaN,
            "formElementValidationMaxLength": NaN
        },
        "metadata": {
            "alignment": "Justify",
            "size": 100
        }
    }

    const regex = /^[a-zA-Z0-9.!\#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/

    const data: FormBuilderProps = {
        "formBuilderData": {
            "contentType": "PuxForm",
            "displayText": "mauticform_trialrequest",
            "metadata": {
                alignment: "",
                size: 100,
            },
            "puxFormOptions": {
                "formAction": WORKFLOW_ACTION,
                "formMethod": "POST",
                "formEncType": "multipart/form-data",
                "formAntiForgeryToken": false,
                "formID": "mauticform_trialrequest",
                "formSuccessMessage": {
                    "html": ""
                },
                "formCustomCssClass": "",
                "formShowLabels": true,
                "formRedirectUrl": {
                    internal: [false],
                    url: "",
                    text: ""
                }
            },
            "puxFormRecaptchaOptions": {
                "formValidateRecaptcha": true
            },
            "puxWidgetProperties": {
                "widgetPropertiesPartID": "",
                "widgetPropertiesPartMarginTop": "",
                "widgetPropertiesPartPaddingTop": "",
                "widgetPropertiesPartMarginBottom": "",
                "widgetPropertiesPartPaddingBottom": "",
                "widgetPropertiesPartMobileOrder": ""
            },
            "flow": {
                "widgets": [
                    {
                        ...inputDefault,
                        "contentType": "PuxFormFieldInput",
                        "displayText": "mauticform[email]",
                        "inputType": "email",
                        "puxFormElement": {
                            "formElementDefaultValue": "",
                            "formElementID": "company-email",
                            "formElementName": "mauticform[email]",
                            "formElementLabel": t`Easy8.Trial.Label`,
                            "formElementPlaceholder": t`Easy8.Trial.Placeholder`
                        },
                        "puxFormElementValidation": {
                            "formElementValidationRequired": true,
                            "formElementValidationMax": NaN,
                            "formElementValidationMaxLength": NaN,
                            "formElementValidationMin": NaN,
                            "formElementValidationMinLength": NaN,
                            "formElementValidationPattern": regex,
                        }
                    },
                    {
                        "contentType": "PuxFormFieldInput",
                        "displayText": "mauticform[first_name]",
                        "inputType": "hidden",
                        "puxFormElement": {
                            "formElementDefaultValue": " ",
                            "formElementID": "mauticform_input_trialrequest_first_name",
                            "formElementName": "mauticform[first_name]",
                            "formElementLabel": " ",
                            "formElementPlaceholder": ""
                        },
                        ...inputDefault
                    },
                    {
                        "contentType": "PuxFormFieldInput",
                        "displayText": "mauticform[last_name]",
                        "inputType": "hidden",
                        "puxFormElement": {
                            "formElementDefaultValue": " ",
                            "formElementID": "mauticform_input_trialrequest_last_name",
                            "formElementName": "mauticform[last_name]",
                            "formElementLabel": " ",
                            "formElementPlaceholder": ""
                        },
                        ...inputDefault
                    },
                    {
                        "contentType": "PuxFormFieldInput",
                        "displayText": "mauticform[identifier]",
                        "inputType": "hidden",
                        "puxFormElement": {
                            "formElementDefaultValue": "notGenerated",
                            "formElementID": "mauticform_input_trialrequest_identifier",
                            "formElementName": "mauticform[identifier]",
                            "formElementLabel": " ",
                            "formElementPlaceholder": ""
                        },
                        ...inputDefault
                    },
                    {
                        "contentType": "PuxFormFieldInput",
                        "displayText": "mauticform[affiliate_account_id]",
                        "inputType": "hidden",
                        "puxFormElement": {
                            "formElementDefaultValue": " ",
                            "formElementID": "mauticform_input_trialrequest_affiliate_account_id",
                            "formElementName": "mauticform[affiliate_account_id]",
                            "formElementLabel": " ",
                            "formElementPlaceholder": ""
                        },
                        ...inputDefault
                    },
                    {
                        "contentType": "PuxFormFieldInput",
                        "displayText": "mauticform[affiliate_conversion_id]",
                        "inputType": "hidden",
                        "puxFormElement": {
                            "formElementDefaultValue": " ",
                            "formElementID": "mauticform_input_trialrequest_affiliate_conversion_id",
                            "formElementName": "mauticform[affiliate_conversion_id]",
                            "formElementLabel": " ",
                            "formElementPlaceholder": ""
                        },
                        ...inputDefault
                    },
                    {
                        "contentType": "PuxFormFieldSubmit",
                        "displayText": "",
                        "formElementName": t`Easy8.Trial.Submit`,
                        "buttonTheme": "default",
                        "buttonSize": "large",
                        "buttonType": "primary",
                        "metadata": {
                            "alignment": "Justify",
                            "size": 100
                        }
                    }
                ]
            },
            "mautic": {
                "formContainerMauticID": "62",
                "formContainerSource": "trial",
                "formContainerSubmissionID": "Easy8;demo;"
            }
        }
    }

    function IDGenerator() {
        const length = 77
        const timestamp = +new Date()

        const _getRandomInt = function (min, max) {
            return Math.floor(Math.random() * (max - min + 1)) + min
        }

        const ts = timestamp.toString()
        const parts = ts.split(``).reverse()
        let id = ``

        for (let i = 0; i < length; ++i) {
            const index = _getRandomInt(0, parts.length - 1)
            id += parts[index]
        }
        return id
    }

    return <FormBuilder {...data} />
}

export default GenericTrialForm









































































































































































































































































































































































































































































































































































